export enum Role {
  Admin = 'Admin',
  Api = 'Api',
  CustomerCare = 'Customer Care',
  Developer = 'Developer',
  ProductOwner = 'ProductOwner',
  ProductManager = 'ProductManager',
  HeadTechnology = 'HeadTechnology',
  Marketing = 'Marketing',
  User = 'User',
  CostView = 'CostView',
  TimeAllocation = 'TimeAllocation',
  Onboarding = 'Onboarding',
  ProductMaturityView = 'ProductMaturityView',
  PlantManager = 'PlantManager',
}

export interface BasicUserDTO {
  idUser: number;
  name: string;
  email: string | null;
  pictureGuid?: string;
}

export interface UserBrief extends BasicUserDTO {
  resourceId?: number;
}

export interface UserWithAvailableHoursDTO extends UserBrief {
  availableHours: number;
  allocatedHours: number;
  hoursLeft: number;
}

export interface UserAdd extends UserBrief {
  password: string;
  confirmPassword: string;
  username: string;
  isAD: boolean;
  adUser: string;
}

export interface RoleDTO {
  idRole: number;
  roleName: Role;
}

export interface UserWithRolesDTO extends UserBrief {
  roles: RoleDTO[];
  resource?: string;
  deletedAt?: string;
}

export interface UserDetails extends UserWithRolesDTO {
  availableHours: UserAvailableHoursDTO[];
}

export interface UserAvailableHoursDTO {
  id: number;
  year: number;
  availableHours: number;
}
